import React from 'react'
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          PayUI
        </a>
        <span className="ms-1">&copy; 2025 - 2026 Copilot Coding Enterprise.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://copilotcoding.services" target="_blank" rel="noopener noreferrer">
          Copilot Coding Enterprise
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
